/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Draf_GInputs */

const en_tut_draf_g = /** @type {(inputs: Tut_Draf_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Writing up minutes after a meeting is the task most often postponed. The AI draft reads the transcript and prepares the skeleton — for you to check, not to send.`)
};

const id_tut_draf_g = /** @type {(inputs: Tut_Draf_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyusun notulen setelah rapat adalah pekerjaan yang paling sering tertunda. Draf AI membaca transkrip dan menyiapkan rangkanya — untuk Anda periksa, bukan untuk langsung dikirim.`)
};

/**
* | output |
* | --- |
* | "Writing up minutes after a meeting is the task most often postponed. The AI draft reads the transcript and prepares the skeleton — for you to check, not to s..." |
*
* @param {Tut_Draf_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_draf_g = /** @type {((inputs?: Tut_Draf_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Draf_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_draf_g(inputs)
	return en_tut_draf_g(inputs)
});